const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternationalGuidelines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M12.9,2.5V2.2c0-0.4,0-0.6-0.5-0.7 c-0.1,0-0.1,0-0.2,0l-7.6,3l8.2,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M13.9,3.4V3.1c0-0.4-0.2-0.7-0.5-0.7h-0.1L5,4.5 l8.9,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M14.8,4.6V4.1c0-0.4-0.3-0.7-0.6-0.7h-0.1 L4.6,4.5L14.8,4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M15.3,18.1H4.4c-0.3,0-0.5-0.2-0.5-0.5V5.1 c0-0.3,0.2-0.5,0.5-0.5h10.8c0.3,0,0.5,0.2,0.5,0.5v12.5C15.8,17.8,15.5,18.1,15.3,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M14.5,12.3H5.4c-0.1,0-0.1-0.1-0.1-0.1l0,0 c0-0.1,0.1-0.1,0.1-0.1h9.1c0.1,0,0.1,0.1,0.1,0.1l0,0C14.6,12.3,14.6,12.3,14.5,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M14.5,13.7H5.4c-0.1,0-0.1-0.1-0.1-0.1l0,0 c0-0.1,0.1-0.1,0.1-0.1h9.1c0.1,0,0.1,0.1,0.1,0.1l0,0C14.6,13.6,14.6,13.7,14.5,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M14.5,15H5.4c-0.1,0-0.1-0.1-0.1-0.1l0,0 c0-0.1,0.1-0.1,0.1-0.1h9.1c0.1,0,0.1,0.1,0.1,0.1l0,0C14.6,15,14.6,15,14.5,15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M14.5,16.4H5.4c-0.1,0-0.1-0.1-0.1-0.1l0,0 c0-0.1,0.1-0.1,0.1-0.1h9.1c0.1,0,0.1,0.1,0.1,0.1l0,0C14.6,16.3,14.6,16.4,14.5,16.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    cx: 9.8,
    cy: 8.5,
    r: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 9.8,
    y1: 6.1,
    x2: 9.8,
    y2: 10.8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M8.9,6.3c0,0-1.5,1.9,0,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M10.7,6.3c0,0,1.5,1.9,0,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M7.5,7.9c0,0,2-1.6,4.6,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M12.1,8.8c0,0-2,1.6-4.7,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternationalGuidelines);
export default __webpack_public_path__ + "static/media/international_guidelines.f76d944f1627645315fca3b80082381d.svg";
export { ForwardRef as ReactComponent };